import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { H1 } from '@hobs/components/Headings';
import { RaisedButton } from '@hobs/components/Buttons';
import './ErrorBoundaries.scss';

class ErrorBoundaries extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error, info });
  }

  goToBeginning = () => {
    window.location.href = '/';
  };

  render() {
    const { hasError, error } = this.state;

    if (hasError) {
      return (
        <div className="error-boundaries">
          <div>
            <H1>Oh no, something went wrong! ð¢</H1>
            <code dangerouslySetInnerHTML={{ __html: error }}></code>
            <RaisedButton onClick={this.goToBeginning}>
              Back to Home
            </RaisedButton>
          </div>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

ErrorBoundaries.propTypes = {
  children: PropTypes.any
};

export default ErrorBoundaries;
